<template>
    <div class="back-to-top">
        <ButtonLink
            v-show="showButton == true"
            icon="back-to-top"
            title="Back To Top"
            link="#"
            variant="secondary"
        ></ButtonLink>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showButton: false,
            lastScrollPosition: 0
        }
    },

    mounted() {
        window.addEventListener("scroll", this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },

    methods: {
        onScroll() {
            const currentScrollPosition =
                window.pageYOffset || document.documentElement.scrollTop

            if (currentScrollPosition > 1000) {
                return
            }

            this.showButton = currentScrollPosition > this.lastScrollPosition

            this.lastScrollPosition = currentScrollPosition
        }
    }
}
</script>

<style lang="scss" scoped>
.back-to-top {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
}
</style>
